import { render, staticRenderFns } from "./DashboardP2P.vue?vue&type=template&id=587a237e&scoped=true&"
import script from "./DashboardP2P.vue?vue&type=script&lang=js&"
export * from "./DashboardP2P.vue?vue&type=script&lang=js&"
import style0 from "./DashboardP2P.vue?vue&type=style&index=0&id=587a237e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a237e",
  null
  
)

export default component.exports